import React from "react";

const CheckMarkIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 22C17.0751 22 22 17.0751 22 11C22 4.92485 17.0751 0 11 0C4.92487 0 0 4.92485 0 11C0 17.0751 4.92487 22 11 22Z"
        fill="#37B24D"
      />
      <path
        d="M3.20201 12.5521L6.8182 16.1391C7.40467 16.7209 8.35111 16.7189 8.93522 16.1348L18.0645 7.00558C18.5639 6.50619 18.5639 5.69651 18.0645 5.19712C17.5651 4.69773 16.7554 4.69773 16.256 5.19712L8.23097 13.2222C8.03571 13.4174 7.71913 13.4174 7.52386 13.2222L5.0242 10.7225C4.51373 10.212 3.68387 10.2193 3.18243 10.7387C2.69186 11.2467 2.70059 12.0547 3.20201 12.5521Z"
        fill="#DDDDDD"
        stroke="#DDDDDD"
      />
    </svg>
  );
};

export default CheckMarkIcon;
